import { shallowMount } from "@vue/test-utils";
import CivilStatus from "@/components/core/composite/combos/CivilStatus";

describe("CivilStatus component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(CivilStatus);
  });

  it("Renders del component CivilStatus", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
